import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ButtonType, IconName } from '@yupma/ui-kit';

@Component({
  selector: 'app-single-date-and-time-picker-input',
  templateUrl: './single-date-and-time-picker-input.component.html',
  styleUrl: './single-date-and-time-picker-input.component.scss'
})
export class SingleDateAndTimePickerInputComponent implements OnInit, OnChanges {
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() value: number = 0;
  @Input() required: boolean = false;
  @Input() hideOptional: boolean = false;
  @Input() error: boolean = false;
  @Input() disabled: boolean = false;
  @Input() inlineInfo: string = '';
  @Input() errorText: string = 'This field is required.';
  @Input() showLabel: boolean = true;
  @Output() valueChange = new EventEmitter<number>();

  iconNames = IconName;
  buttonTypes = ButtonType;
  dateValue: Date | null = null;

  ngOnChanges(changes: SimpleChanges) {
    if (!!changes['value']) {
      this.convertValueToDate()
    }
  }

  ngOnInit() {
    this.convertValueToDate()
  }

  convertValueToDate() {
    if (this.value) {
      this.dateValue = new Date(Number(this.value));
    }
  }


  updateDateValue(value: Date) {
    if (!this.dateValue) {
      const currentTime = new Date;
      this.dateValue = value;
      this.dateValue?.setHours(currentTime.getHours());
      this.dateValue?.setMinutes(currentTime.getMinutes());
      this.dateValue?.setSeconds(0);
    }
    this.dateValue?.setFullYear(value.getFullYear(), value.getMonth(), value.getDate());
    this.savePopup();
  }

  updateTimeValue(value: Date) {
    if (!this.dateValue) {
      this.dateValue = value;
    }
    this.dateValue?.setHours(value.getHours());
    this.dateValue?.setMinutes(value.getMinutes());
    this.dateValue?.setSeconds(0);
    this.savePopup();
  }

  clearField() {
    this.dateValue = null;
    this.savePopup();
  }

  savePopup() {
    if (this.dateValue) {
      this.value = this.dateValue.getTime();
      this.valueChange.emit(this.value);
    } else {
      this.dateValue = null;
      this.value = 0;
      this.valueChange.emit(this.value);
    }
  }
}
